// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1C08J","emails":"CreateEditClinics_emails__31RIV","emailTagLabel":"CreateEditClinics_emailTagLabel__1SXhR"};